// The Apsio mark (docs/brand.md v2, Mark): the orbit ring, the device inside it and the closest
// point lit in the accent on the ring.
export function Mark() {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" focusable="false">
      <g transform="rotate(-22 16 16)">
        <ellipse
          cx="16"
          cy="16"
          rx="14"
          ry="9.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.6"
        />
        <circle cx="21" cy="16" r="3.2" fill="currentColor" />
        <circle className="mark-peri" cx="30" cy="16" r="3.4" />
      </g>
    </svg>
  )
}
